import * as React from 'react';
import TimezoneSelect from 'react-timezone-select';
function EditTimeZoneSelect(props) {
    var value = props.value, onChange = props.onChange;
    var handleChange = function (timezone) {
        onChange(timezone.value);
    };
    return React.createElement(TimezoneSelect, { value: value || '', onChange: handleChange });
}
export default EditTimeZoneSelect;
